import LegalLayout from './LegalLayout';

const MentionsLegalesPage = () => (
  <LegalLayout title="Mentions légales">
    <p data-testid="legal-mentions-intro">
      Les présentes mentions légales s'appliquent au site accessible à l'adresse
      <strong> odelicieuse.eu</strong>.
    </p>

    <h2 className="text-xl font-semibold text-heading mt-6 mb-2">1. Éditeur du site</h2>
    <ul className="list-disc pl-6 space-y-1">
      <li><strong>Raison sociale :</strong> Ô'Délicieuse SRL</li>
      <li><strong>Siège social :</strong> Rue Marie-Christine 32, 1020 Bruxelles, Belgique</li>
      <li><strong>Numéro BCE :</strong> [À compléter]</li>
      <li><strong>Numéro de TVA :</strong> [À compléter]</li>
      <li><strong>Responsable de la publication :</strong> [À compléter]</li>
      <li><strong>Contact :</strong> contact@odelicieuse.eu — +32 493 32 88 62</li>
    </ul>

    <h2 className="text-xl font-semibold text-heading mt-6 mb-2">2. Hébergement</h2>
    <p>
      Le site est hébergé par Emergent Labs via son infrastructure cloud. Pour toute demande
      relative à l'hébergement, veuillez nous contacter.
    </p>

    <h2 className="text-xl font-semibold text-heading mt-6 mb-2">3. Propriété intellectuelle</h2>
    <p>
      L'ensemble des éléments présents sur ce site (textes, images, logos, graphismes, marques,
      base de données) sont la propriété exclusive de Ô'Délicieuse SRL ou de ses partenaires.
      Toute reproduction, représentation, modification, publication ou adaptation, totale ou
      partielle, quel que soit le moyen ou le procédé utilisé, est interdite sans l'autorisation
      écrite préalable de Ô'Délicieuse SRL.
    </p>

    <h2 className="text-xl font-semibold text-heading mt-6 mb-2">4. Données personnelles</h2>
    <p>
      Le traitement de vos données personnelles est détaillé dans notre{' '}
      <a href="/confidentialite" className="text-[color:var(--color-primary)] hover:underline">
        politique de confidentialité
      </a>
      .
    </p>

    <h2 className="text-xl font-semibold text-heading mt-6 mb-2">5. Cookies</h2>
    <p>
      L'utilisation des cookies est détaillée dans notre{' '}
      <a href="/cookies" className="text-[color:var(--color-primary)] hover:underline">politique de cookies</a>.
    </p>

    <h2 className="text-xl font-semibold text-heading mt-6 mb-2">6. Loi applicable</h2>
    <p>
      Les présentes mentions légales sont soumises au droit belge. En cas de litige, les
      tribunaux de Bruxelles seront seuls compétents.
    </p>

    <p className="text-xs text-muted mt-8 italic">
      Dernière mise à jour : {new Date().toLocaleDateString('fr-BE', { day: '2-digit', month: 'long', year: 'numeric' })}.
    </p>
  </LegalLayout>
);

export default MentionsLegalesPage;
